module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921122649_T.492c9a53.jpg";